import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@headlessui/react';
import { IconCheveronDown } from '../Icons';
import SelectMenuContext from './SelectMenuContext';

const SelectMenu = ({
  children,
  label,
  className,
  multiple = false,
  rightAlignDropdown = false,
}) => {
  const contextValue = useMemo(() => ({ multiple }), [multiple]);

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            className={`flex w-full items-center justify-between rounded border p-3 text-slate-600 leading-tight mb-2 ${
              className && className
            }
            ${open ? 'border-blue-500' : 'border-slate-200'}`}
          >
            <span className="truncate">{label}</span>
            <div className="pointer-events-none flex items-center text-slate-600">
              <IconCheveronDown className={open ? 'rotate-180 transform' : ''} size="5" />
            </div>
          </Popover.Button>
          <Popover.Panel
            static
            className={`absolute bg-white border rounded border-slate-200 shadow-lg z-popup-backdrop ${
              rightAlignDropdown ? 'right-0' : ''
            }`}
            hidden={!open}
          >
            <SelectMenuContext.Provider value={contextValue}>{children}</SelectMenuContext.Provider>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

SelectMenu.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  multiple: PropTypes.bool,
  rightAlignDropdown: PropTypes.bool,
  className: PropTypes.string,
};

SelectMenu.defaultProps = {};

export default SelectMenu;
